import {FINANCE_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  getClient (id) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.get('clients/' + id)
  },
  getClientsList ({limit = 50, page = 1, search}) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const fullRequest = [`page=${page}`, `limit=${limit}`, 'sort[]=nickName', 'contactType[]=1']
    if (search) fullRequest.push(`search=${search}`)
    const address = search ? 'clients?' : 'clients/withoutelastic?'
    return instCred.get(address + fullRequest.join('&'))
  },
  getClientsSelect ({contactType}) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'company': VueCookie.get('company'),
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    const query = []
    if (contactType) query.push(contactType)
    return instCred.get(`clients/getSelect?${query.join('&')}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/Clients/api.js